module.exports = __webpack_public_path__ + "static/img/充电桩.5abd89c1.png";